import { DataTranslations } from './types';

export const zhData: DataTranslations = {
  questions: {
    '1': { question: '什么颜色最适合你的完美心情？' },
    '2': { question: '哪双鞋能展现你的魅力？' },
    '3': { question: '你的标志性美妆动作是什么？' },
    '4': { question: '你的时尚灵感是什么？' },
    '5': { question: '想象你的梦想周末？' },
    '6': { question: '你的美妆座右铭？' },
    '7': { question: '巴黎最有灵魂的地方？' },
    '8': { question: '如果可以品尝一杯饮品？' },
    '9': { question: '描述你最喜欢的嗅觉系列？' },
    '10': { question: '如果只能选择一种食物享用，你会选什么？' },
    '11': { question: '谁将佩戴这款香氛？' },
    '12': { question: '你希望她/他佩戴 Christian Louboutin 香氛时有什么感觉？' },
    '13': { question: '以下哪种香调最符合你的个性？' },
    '14': { question: '你喜欢多浓郁的香氛？', minLabel: '淡雅', maxLabel: '浓郁' },
  },

  answers: {
    '1': { label: '标志性红色' },
    '2': { label: '经典裸色' },
    '3': { label: '活力粉色' },
    '4': { label: '温暖珊瑚色' },
    '5': { label: '经典细高跟鞋' },
    '6': { label: '优雅乐福鞋' },
    '7': { label: '休闲运动鞋' },
    '8': { label: '精致凉鞋' },
    '9': { label: '性感红唇' },
    '10': { label: '哑光质感唇妆' },
    '11': { label: '大胆叠涂唇妆' },
    '12': { label: '光泽水润唇妆' },
    '13': { label: '性感力量' },
    '14': { label: '永恒优雅' },
    '15': { label: '潮流前卫' },
    '16': { label: '轻松时尚' },
    '17': { label: '华丽晚宴派对' },
    '18': { label: '屋顶早午餐' },
    '19': { label: '说走就走的旅行' },
    '20': { label: '金色阳光下的野餐' },
    '21': { label: '彰显个性' },
    '22': { label: '从容自信' },
    '23': { label: '打破规则' },
    '24': { label: '自然光泽' },
    '25': { label: 'Galerie Véro-Dodat', description: '奢华购物' },
    '26': { label: 'Palais Garnier', description: '文化殿堂' },
    '27': { label: 'Moulin Rouge', description: '不眠之夜' },
    '28': { label: 'Jardin des Tuileries', description: '浪漫自然' },
    '29': { label: '一杯红酒' },
    '30': { label: '一杯精致鸡尾酒' },
    '31': { label: '一杯香茶' },
    '32': { label: '一杯柠檬水' },
    '33': { label: '木质西普调' },
    '34': { label: '花香清新调' },
    '35': { label: '皮革辛香调' },
    '36': { label: '琥珀果香调' },
    '37': { label: '浓香咖啡收尾' },
    '38': { label: '花香甜点' },
    '39': { label: '海盐焦糖' },
    '40': { label: '水果挞' },
    '41': { label: '自用' },
    '42': { label: '送礼' },
    '43': { label: '充满力量' },
    '44': { label: '优雅大方' },
    '45': { label: '大胆前卫' },
    '46': { label: '光芒四射' },
    '47': { label: '花香调', description: '玫瑰、薰衣草、茉莉...' },
    '48': { label: '琥珀果香调', description: '零陵香豆、樱桃、无花果...' },
    '49': { label: '木质西普调', description: '沉香、檀香、广藿香...' },
    '50': { label: '皮革辛香调', description: '乳香、胡椒、麂皮...' },
  },

  allures: {
    '1': {
      label: '充满力量',
      description: '当自信低语，欲望便会倾听。魅力流淌于每一个姿态中，以自然的力量吸引所有目光。你的美妆仪式成为一种感性的存在宣言——以大胆的质感和精致的细节雕琢而成。嘴唇如同漆面高跟鞋般闪耀。香氛如同无形的签名，一种不可抗拒的力量。',
    },
    '2': {
      label: '优雅大方',
      description: '当永恒遇见现代，风格便成为本能。你的美妆仪式是你高雅审美的映射：雕塑般的质感、柔和的轮廓，以及捕捉纯粹优雅精髓的香氛。',
    },
    '3': {
      label: '出其不意',
      description: '轻松却令人难忘，你的魅力以敏锐的时尚嗅觉打破常规。你的美妆仪式层次分明且充满直觉——大胆的质感与意想不到的音符交织。充满对比的香调，出人意料的搭配。永远独特，从不平凡。',
    },
    '4': {
      label: '光芒四射',
      description: '你无需追逐关注——你自带光芒。轻松而明亮，你的美丽如同第二层肌肤。它以柔和的色调和从容的自信展开，以本能的优雅表达。你的仪式是本能的——轻盈如羽的质感、清透的色彩，以及捕捉新生光辉的香氛。',
    },
  },

  makeupServices: {
    '0': {
      title: '快速闪亮',
      description: '探索3款标志性 Christian Louboutin 产品，提升你的妆容。',
    },
    '1': {
      title: '魅力点缀',
      description: '为完美双唇、提亮肤色或加深眼妆打造的专属时刻。',
    },
    '2': {
      title: '标志性妆容',
      description: '选择品牌标志性妆容之一，通过个性化建议和技巧学习如何打造。',
    },
    '3': {
      title: '量身定制妆容',
      description: '特别场合？享受量身定制的服务，由品牌专家为你打造妆容。',
    },
  },

  fragranceServices: {
    '0': {
      title: '发现你的专属香氛',
      description: '一次独享的感官体验，找到最适合你的 Christian Louboutin 香氛。',
    },
    '1': {
      title: '发现你的魅力',
      description: '踏入 Louboutin 的世界——通过沉浸式数字问卷，揭示你的终极魅力。',
    },
  },

  products: {
    '1': {
      description: '一朵精致的玫瑰，一首真正的嗅觉赞歌。感性的极致诱惑，以樱桃和弦的俏皮撩拨与醉人玫瑰的迷恋芬芳交织而成。',
      olfactiveNotes: '樱桃 & 玫瑰',
    },
    '2': {
      description: '前所未有的皮革体验。感性的桂花与丝滑麂皮交融，一款令人惊叹的第二肌肤般的香氛。',
      olfactiveNotes: '桂花 & 麂皮',
    },
    '3': {
      description: '芳香而精致的薰衣草三重奏。一场大胆的实验，薰衣草的明亮芳香沉浸于皮革的深沉而强大的拥抱之中。',
      olfactiveNotes: '黑色皮革 & 薰衣草',
    },
    '4': {
      description: '极致的沉迷，深入灵魂。以无花果的甜美诱惑开篇，渐入檀香的温暖深处。',
      olfactiveNotes: '无花果 & 檀香',
    },
    '5': {
      description: '琥珀与晚香玉的邂逅，前所未闻的香氛体验。清新翠绿的开场与温暖醉人的琥珀交融。',
      olfactiveNotes: '晚香玉 & 琥珀',
    },
    '6': {
      description: '高贵的雪松木以出人意料的方式与一缕不可抗拒的高品质椰子水形成对比。',
      olfactiveNotes: '椰子 & 雪松木',
    },
    '7': {
      description: '我们最质朴的嗅觉创作：以木质而富有质感的广藿香重新诠释鸢尾根精华，打造极致奢华、最贴近大地的香氛。',
      olfactiveNotes: '广藿香 & 鸢尾根',
    },
    '8': {
      description: '温暖与冰冷香料的鸡尾酒。冰冷犀利的胡椒的清新感与乳香温暖而神秘的气息融为一体。',
      olfactiveNotes: '黑胡椒 & 乳香',
    },
    '42': {
      description: '一首感性的嗅觉乐章，揭示白桃多汁的甜美，既明亮又丝滑，拥抱沉香深沉而烟熏的优雅。这场邂逅留下奢华而不可抗拒的深邃余韵。',
      olfactiveNotes: '白桃 & 沉香',
    },
  },

  looks: {
    '5': { title: '新潮妆容' },
    '4': { title: '季节妆容' },
    '1': { title: '红色女王' },
    '2': { title: '原子砖红' },
    '3': { title: '爆炸绿' },
  },
};
